import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { browserGpsInfo, isLargeScreen } from '../../../../../global.variable';
import { UserProfileService } from '../../../../profile/user-profile/user-profile.service';
import { ModalDialogueService } from '../../../../shared/components/modal-dialogue/modal-dialogue.service';
import { LoadingSpinnerService } from '../../../../shared/services/loading-spinner.service';
import { ToasterService } from '../../../../shared/services/toaster.service';
import { PagesService } from '../../pages.service';
import { sosAlertDetailView } from '../../tableDetails';
import { UsersService } from '../../users/users.service';

@Component({
  selector: 'gtapp-sos-alerts',
  templateUrl: './sos-alerts.component.html',
  styleUrl: './sos-alerts.component.scss',
  standalone: false,
})
export class SosAlertsComponent implements OnInit, OnDestroy {
  sosAlerts: any = [];

  selectedAlert: any;

  currentSOSAlertCount: number = 0;
  isAlertActive: boolean = false;

  acknowledgeForm: UntypedFormGroup = new UntypedFormGroup({
    inquired: new UntypedFormControl(false, Validators.required),
    comment: new UntypedFormControl(null, Validators.required),
  });

  initialValues = { ...this.acknowledgeForm.value };

  // sos alert history values
  @ViewChild('detailsSection')
  detailsSection!: ElementRef;

  selectedEvent: any;
  browserGpsInfo: any = browserGpsInfo;

  userEventDetailsTableView: any = sosAlertDetailView.desktopTable;

  previousSOSAlertsHistory: number = 0;
  pageSizeSOSAlertsHistory: number = 10;
  pageNumSOSAlertsHistory: number = 1;
  totalPagesSOSAlertsHistory: number = 0;
  totalRowsSOSAlertsHistory: number = 0;
  sortKeysSOSAlertsHistory: any = ['-updated_at'];
  searchParamsSOSAlertsHistory: any;
  sosAlertHistoryData: any = [];
  dateRangeSOSAlertsHistory: any;
  otherParamsSOSAlertsHistory: any = {};

  tableStyle = {
    'overflow': 'auto',
    'max-height': '600px',
  };

  guardAlertData: any;
  largeView: Boolean = isLargeScreen;

  miscSubjectParamSubscription: any;
  scrollPosition: any;
  constructor(
    private userService: UsersService,
    private spinnerService: LoadingSpinnerService,
    private profileService: UserProfileService,
    private pageService: PagesService,
    private dialogService: ModalDialogueService,
    private route: ActivatedRoute,
    private router: Router,
    private toasterService: ToasterService,
    private viewContainerRef: ViewContainerRef,
  ) {
    this.route.params.subscribe({
      next: (params: any) => {
        try {
          const alertCounts = Number(params?.alertCounts);
          if (alertCounts && alertCounts !== this.currentSOSAlertCount) {
            this.currentSOSAlertCount = alertCounts;
            this.isAlertActive = true;

            this.getSOSAlerts();
            this.getSOSAlertsHistory();
          }
        } catch (error) {}
      },
    });
  }

  ngOnInit(): void {
    if (!this.currentSOSAlertCount) {
      this.getSOSAlerts();
      this.getSOSAlertsHistory();

      this.router.navigate([], {});
    }

    this.miscSubjectParamSubscription =
      this.pageService.miscSubjectParam.subscribe((value: any) => {
        this.isAlertActive = value?.sosAlertActive === 'alertActive';
      });
  }
  ngOnDestroy(): void {
    if (this.miscSubjectParamSubscription)
      this.miscSubjectParamSubscription?.unsubscribe();
  }

  getSOSAlerts() {
    this.spinnerService.show();

    let body: any = {
      event_type: 'sos_alerts',
      search_filters: {},
      rows: 25,
    };

    this.userService
      .getUserUpdateLog(body, { pending: 1 })
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.sosAlerts = response?.data;
          if (this.sosAlerts?.length === 1) {
            this.showGps(0);
          }

          this.spinnerService.hide();
        } else {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response['message'],
          });
          this.spinnerService.hide();
        }
      });
  }
  showGps(selectedIndex: number) {
    this.sosAlerts?.forEach(
      (sosAlert: any, index: number) =>
        (sosAlert.showGps = index === selectedIndex),
    );
  }
  openAlertTemplate(template: any, sosAlert: any) {
    this.guardAlertData = sosAlert;
    this.acknowledgeForm.reset(this.initialValues);
    this.dialogService.open(
      template,
      { data: this.guardAlertData },
      this.viewContainerRef,
    );
  }
  muteAlert() {
    this.pageService.miscSubjectParam.next({ sosAlertActive: 'turnOff' });
  }
  acknowledgeAlert() {
    this.spinnerService.show();
    this.profileService
      .updateUser(
        { alert_id: this.selectedAlert?.id, ...this.acknowledgeForm.value },
        { acknowledge_sos: 1 },
      )
      .then((response: any) => {
        if (response?.status == 'success') {
          this.spinnerService.hide();
          this.toasterService.setMessage({
            successMessage: response?.message,
            errorMessage: '',
          });

          this.sosAlerts = response?.data;
          if (this.sosAlerts?.length === 1) {
            setTimeout(() => {
              this.showGps(0);
            }, 500);
          }
          this.getSOSAlertsHistory();
          if (!this.sosAlerts?.length) {
            this.currentSOSAlertCount = 0;
            this.router
              .navigate(['/sos-welfare-alerts'], {
                fragment: 'sosAlerts',
              })
              .then(() => window.location.reload());
          }
        } else {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response?.message,
          });
          this.spinnerService.hide();
        }
      });
  }
  getSOSAlertsHistory() {
    this.spinnerService.show();

    let body: any = {
      event_type: 'sos_alerts',
      search_filters: {},
    };

    if (this.dateRangeSOSAlertsHistory)
      body.date_range = this.dateRangeSOSAlertsHistory;
    if (this.sortKeysSOSAlertsHistory)
      body.sort_key = this.sortKeysSOSAlertsHistory;
    if (this.searchParamsSOSAlertsHistory)
      body.search_filters = this.searchParamsSOSAlertsHistory;
    if (this.pageSizeSOSAlertsHistory)
      body.rows = this.pageSizeSOSAlertsHistory;
    if (this.previousSOSAlertsHistory)
      body.previous = this.previousSOSAlertsHistory;

    this.userService.getUserUpdateLog(body).subscribe((response: any) => {
      if (response['status'] == 'success') {
        this.sosAlertHistoryData = response['data'];

        this.totalRowsSOSAlertsHistory = response?.total_size;
        this.totalPagesSOSAlertsHistory = Math.ceil(
          response?.total_size / this.pageSizeSOSAlertsHistory,
        );
        this.otherParamsSOSAlertsHistory.paginationData = {
          totalRows: response?.total_size,
          previousRows: this.previousSOSAlertsHistory,
          rows: this.pageSizeSOSAlertsHistory,
          pageNum: this.pageNumSOSAlertsHistory,
          totalPages: this.totalPagesSOSAlertsHistory,
        };

        this.spinnerService.hide();
      } else {
        this.toasterService.setMessage({
          successMessage: '',
          errorMessage: response['message'],
        });
        this.spinnerService.hide();
      }
    });
  }
  onTableRowClickSOSAlertsHistory(event: any) {
    this.scrollPosition = window.scrollY;
    this.selectedEvent = event;
  }

  sortColumnSOSAlertsHistory(body: any) {
    this.sortKeysSOSAlertsHistory = body?.sortList || [];
    this.searchParamsSOSAlertsHistory = body?.searchParams || {};
    this.getSOSAlertsHistory();
  }
  searchColumnSOSAlertsHistory(event: any) {
    this.dateRangeSOSAlertsHistory = event?.date || null;
    this.searchParamsSOSAlertsHistory = event?.searchParams || {};
    this.getSOSAlertsHistory();
  }
  hideDetails() {
    this.selectedEvent = null;
    setTimeout(() => {
      window.scrollTo(0, this.scrollPosition);
    }, 100);
  }

  onChangePaginationSOSAlertsHistory(event: any) {
    this.previousSOSAlertsHistory = event?.paginationData?.previousRows;
    this.pageNumSOSAlertsHistory = event?.paginationData?.pageNum;
    this.pageSizeSOSAlertsHistory = event?.paginationData?.rows;
    this.otherParamsSOSAlertsHistory.paginationData = {
      ...event?.paginationData,
    };
    this.getSOSAlertsHistory();
  }
}
